export const systemName = state => state.common.systemName;
export const systemNameEn = state => state.common.systemNameEn;
export const screen = state => state.common.screen;
// 一级导航
export const firstMenuMutation = state => state.common.firstMenuMutation;
export const firstMenuMapMutation = state => state.common.firstMenuMapMutation;
// 二级导航
export const secondMenuMutation = state => state.common.secondMenuMutation;
export const secondMenuMapMutation = state => state.common.secondMenuMapMutation;
// 三级导航
export const thirdMenuMutation = state => state.common.thirdMenuMutation;
export const thirdMenuMapMutation = state => state.common.thirdMenuMapMutation;

export const baseImageUrl = state => state.common.baseImageUrl;